import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { errorMessage, login, register } from './api';

/** Login: il backend imposta il cookie HttpOnly, il JS non tocca token. */
export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  // stessa schermata per entrare e per iscriversi: due pagine per due campi
  // uguali sono solo un passaggio in più
  const [nuovo, setNuovo] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setPending(true);
    setError(null);
    try {
      if (nuovo) await register(email.trim(), password);
      else await login(email.trim(), password);
      navigate('/', { replace: true });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={onSubmit}>
        <p className="brand-mark login-mark" aria-hidden="true"><span className="brand-eye" /></p>
        <h1>Osservio</h1>
        <p className="muted">{nuovo ? 'Crea il tuo account' : 'Accedi per continuare'}</p>
        <label className="field">
          <span>Email</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
          />
        </label>
        <div className="field">
          <label htmlFor="login-password">Password</label>
          <span className="password-control"><input id="login-password" type={showPassword ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)} autoComplete={nuovo ? 'new-password' : 'current-password'} minLength={nuovo ? 8 : undefined} required/><button type="button" onClick={() => setShowPassword((value) => !value)} aria-label={showPassword ? 'Nascondi password' : 'Mostra password'}>{showPassword ? 'Nascondi' : 'Mostra'}</button></span>
        </div>
        {error && <p className="error">{error}</p>}
        {nuovo && <p className="muted login-hint">La password deve avere almeno 8 caratteri.</p>}
        <button type="submit" className="btn-primary" disabled={pending}>
          {pending ? (nuovo ? 'Creo l’account…' : 'Accesso…') : (nuovo ? 'Crea account' : 'Entra')}
        </button>
        <button type="button" className="btn-quiet login-switch" onClick={() => { setNuovo((v) => !v); setError(null); }}>
          {nuovo ? 'Ho già un account: accedi' : 'Non hai un account? Creane uno'}
        </button>
      </form>
    </div>
  );
}
